import {Box, styled} from '@mui/material';
import {grey} from '@mui/material/colors';

export const Puller = styled(Box)(({theme}) => ({
  width: 40,
  height: 6,
  backgroundColor: grey[400],
  borderRadius: 3,
  position: 'absolute',
  top: 12,
  left: 'calc(50% - 15px)',
}));
